import React, { Component } from 'react';
import utilFunction from '../../containers/function'
import LineChart from '../common/graphs/crossfilterGraphs/lineChart';


const FulfillmentAtRiskEvolutionGraph = (props) => (
  	<div className="container-detail-graph-table">
        <div className="dc-chart-parent evolution-graph">
          <LineChart 
            id={props.id} 
            additionalCrossfilterData={null}
            crossfilerData={utilFunction.generateCrossfilter(props.data)}
            stack={false} 
            dimension={{
              formatFunction:[],
              name:"date",
              originalName:"date",
              reduceFunction:{type: "CONTINUOUS_GROUP", typeof: "DATE_TIME"}
            }}
            metrics={[{
              config:{},
              filter: [],
              formatFunction: [],
              metric: "percentage",
              name: "percentage",
              reduceFunction: {type: "AVG"},
              type: "AVG"
            }]} 
            config={{
              
              "tooltip":{
                "valuesConfig":[
                  {"identifier":"x","valueFormat":{"type":"DATE_TIME_UTC","format":"%d-%m-%Y"},"wrapper":"<div>%v</div>"},
                  {"identifier":"y","valueFormat":{"type":"NUMBER","format":".0f"},"wrapper":"<div>En riesgo: <span style='font-weight:bold;'>%v%</span></div>","colorRange":[
                    {"color":"#E14D57","range":[{"value":50,"operator":"<"}]},
                    {"color":"#EC932F","range":[{"value":50,"operator":">="},{"value":85,"operator":"<"}]},
                    {"color":"#71B37C","range":[{"value":85,"operator":">="}]}
                  ]}
              ]},
              "renderArea":true,
              "interpolation":"linear",
              "stroke":2.4,
              "colors":["#aeb2b1"],
              "dataPoints":{"show":true,"radius":3},
              "xAxis":{"show":false,"interval":1,"intervalDateUnit":"DAY","format":"%d-%m","rotation":0},
              "yAxis":{"show":false,"horizontalLines":false,"ticksNumber":2,"format":".0f","autoRange":{"active":false,"max":100,"min":0}}
            }}
            dashboardId={"summary_fulfillmenta"}
          />
        </div>
    </div>
);
  
export default FulfillmentAtRiskEvolutionGraph;


// WEBPACK FOOTER //
// ./source/client/components/detail_fulfillment/evolutionGraph.jsx